import { CONTACT } from "@/data/content";

export const SITE_NAME = "Risi Wellness Limited";
export const SITE_URL = process.env.REACT_APP_SITE_URL || "https://risiwellness.co.uk";

export const DEFAULT_DESCRIPTION =
  "Professional mobile massage and holistic wellness services from Risi Wellness Limited.";

export const ROUTE_SEO = {
  "/": {
    title: "Mobile Massage & Wellness in Manchester",
    description:
      "Risi Wellness Limited provides mobile massage and holistic wellness services for homes, hotels and workplaces.",
  },
  "/about": {
    title: "About Risi Wellness Limited",
    description:
      "Learn about Risi Wellness Limited and its mobile wellness service in Manchester.",
  },
  "/services": {
    title: "Massage & Wellness Services in Manchester",
    description:
      "Explore the mobile massage and wellness services available from Risi Wellness Limited.",
  },
  "/benefits": {
    title: "Wellness Benefits",
    description:
      "Learn more about the wellbeing aims and experience behind Risi Wellness treatments.",
  },
  "/booking": {
    title: "Book a Risi Wellness Treatment",
    description: "Choose an appointment time through the Risi Wellness Calendly booking page.",
    robots: "noindex, follow",
  },
  "/contact": {
    title: "Contact Risi Wellness Limited",
    description:
      "Contact Risi Wellness Limited about mobile massage and wellness services.",
  },
  "/faq": {
    title: "Risi Wellness Frequently Asked Questions",
    description:
      "Answers to common questions about Risi Wellness mobile massage and wellness services.",
  },
  "/gallery": {
    title: "Risi Wellness Gallery",
    description: "View the Risi Wellness treatment and wellbeing gallery.",
  },
  "/legal/privacy": {
    title: "Privacy Policy | Risi Wellness Limited",
    description: "Read the Risi Wellness Limited privacy policy.",
  },
  "/legal/cookies": {
    title: "Cookie Policy | Risi Wellness Limited",
    description: "Read the Risi Wellness Limited cookie policy.",
  },
  "/legal/terms": {
    title: "Terms & Conditions | Risi Wellness Limited",
    description: "Read the Risi Wellness Limited terms and conditions.",
  },
};

export const getCanonical = (pathname) => `${SITE_URL}${pathname === "/" ? "/" : pathname}`;

export const getOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: SITE_NAME,
  url: SITE_URL,
  logo: `${SITE_URL}/logo.png`,
  email: CONTACT.email,
  telephone: CONTACT.mobile,
  sameAs: [CONTACT.socials.instagram, CONTACT.socials.tiktok, CONTACT.googleBusinessProfile].filter(Boolean),
});

export const getWebPageSchema = ({ title, description, pathname }) => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": `${getCanonical(pathname)}#webpage`,
  url: getCanonical(pathname),
  name: title,
  description,
  isPartOf: { "@id": `${SITE_URL}/#website` },
});
